import { render, staticRenderFns } from "./QuestionMaster_v2.vue?vue&type=template&id=487cfac9&"
import script from "./QuestionMaster_v2.vue?vue&type=script&lang=js&"
export * from "./QuestionMaster_v2.vue?vue&type=script&lang=js&"
import style0 from "./QuestionMaster_v2.vue?vue&type=style&index=0&id=487cfac9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports